import React from 'react'
import { getSegments } from './../../core/api/segments-provider'
import { Carousel, About, ImageTitleButtonBlock, SegmentCard } from './../../components'
import { Row, Col, Container } from 'react-bootstrap'

const Segmentos = () => {

    const [segmentsData, setSegmentsData] = React.useState()

    React.useEffect(() => {
        getSegments().then((res) => setSegmentsData(res.data))
    }, [])

    return (
        <>
            {
                segmentsData && (
                    <>
                        <Carousel slides={segmentsData.slides}/>
                        <Container fluid>
                            <Row className='mt-5'>
                                <Col xs={{
                                    span: 10,
                                    offset: 1
                                }}>
                                    <Row className='d-flex flex-row justify-content-center'>
                                        {
                                            segmentsData.cards_segment.map(card => (
                                                <Col lg={3} xs={12} className='mx-lg-2 mx-0 my-3 my-lg-0'>
                                                    <SegmentCard title={card.title} image={card.image} />
                                                </Col>
                                            ))
                                        }
                                    </Row>
                                </Col>
                            </Row>

                            <Row>
                                <Col xs={{
                                    span: 10,
                                    offset: 1
                                }}>
                                    {
                                        segmentsData?.about.map((about, index) => (
                                            <Row className='my-5'>
                                                <Col xs={12}>
                                                    <About
                                                        key={index}
                                                        image_group={about.image_group}
                                                        content_group={about.content_group}
                                                        margin='5% 0px'
                                                        alignment={about.alignment}
                                                    />
                                                </Col>
                                            </Row>
                                        ))
                                    }

                                </Col>
                            </Row>

                            <Row className='my-5'>
                                <Col xs={12} className='mb-5 px-0'>
                                    <ImageTitleButtonBlock
                                        image={segmentsData.block_image_title_button.image}
                                        title={segmentsData.block_image_title_button.title}
                                        button={segmentsData.block_image_title_button.button}
                                        
                                    />
                                </Col>
                            </Row>
                        </Container>

                    </>
                )
            }
        </>
    )
}

export default Segmentos